import React from "react";
import { Link } from "react-router-dom";
import Location from "../components/Location/Location";
import Footer from "../components/Footer";

function LocationPage() {
  return (
    <div className="page-container">
      <div className="content-wrap">
        <Location />
      </div>
    </div>
  );
}

export default LocationPage;
